import React, { useEffect } from 'react';
import PageHeader from '../Shared/PageHeader';
import PageOverlayContent from '../Shared/PageOverlayContent';
import { StakeholderDocumentRow } from '../../models/stakeholderDocumentRow';
import StakeholderDocumentTable from '../Shared/StakeholderDocumentTable';
import { getStakeholderDocumentsApi } from '../../utils/StakeholderDocumentUtil';
import { Helmet } from 'react-helmet';
import { PageTitles } from '../../utils/PageTitles';
import './Accreditation.css';

const Accreditation = () => {
  const [allData, setAllData] = React.useState<StakeholderDocumentRow[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);

  const getStakeholderDocuments = (
    callback: (fileCategory: string) => Promise<StakeholderDocumentRow[]>,
  ) => {
    // Return the document
    callback('Accreditation')
      .then((documentTable) => {
        // Set the state for containerName

        // Set the state for the new documents
        setAllData(documentTable);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  // useEffect to initialise documents
  useEffect(() => {
    getStakeholderDocuments(getStakeholderDocumentsApi);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Helmet>
        <title>{PageTitles.Accreditation}</title>
      </Helmet>
      <PageHeader headerTitle="Accreditation" hasOverlay={true} isAdmin={false}>
        {
          'See your PLB Accreditation Certificates here.\nA PLB Accreditation Certificate is issued by DXC once Configuration Acceptance Testing is successfully completed.'
        }
      </PageHeader>
      <PageOverlayContent>
        <div className="Overlay_box">
          <StakeholderDocumentTable
            data={allData}
            tableName={'Accreditation'}
            isLoading={isLoading}
            canSeeUploader={true}
            canUpload={false}
            canDelete={false}
            isAccordion={false}
            fileCategory={'Accreditation'}
          />
        </div>
      </PageOverlayContent>
    </>
  );
};

export default Accreditation;
